<template>
  <div>
    <v-card class="mt-3 mb-3" flat color="secondary">
      <v-card-text class="pt-2 pb-2">
        <v-expansion-panels v-model="PanelSeq">
          <draggable
            v-model="sections"
            group="sections"
            handle=".questions-drag-icon"
            style="width: 100%"
          >
            <a-expansion-panel
              v-for="(section, index) in sections"
              :key="section.sectionId"
              class="mt-2 mb-2 section-panels"
              :data-section="index"
            >
              <v-expansion-panel-header
                class="pa-3 text--white"
                disable-icon-rotate
              >
                <template v-slot:default="{ open }">
                  <v-row no-gutters>
                    <v-col cols="1" class="ma-auto">
                      <v-icon small color="white" class="questions-drag-icon"
                        >mdi-cursor-move</v-icon
                      >
                    </v-col>
                    <v-col cols="1" class="ma-auto">
                      <span v-if="open" key="0">
                        <a-chip
                          small
                          color="Neutral"
                          style="
                            border: 1px solid var(--v-secondary-base) !important;
                          "
                        >
                          {{ `${$t("poll.lblSection")} ${index + 1}` }}
                        </a-chip>
                      </span>
                      <span v-else key="1">
                        <a-chip
                          small
                          color="Neutral"
                          style="
                            border: 1px solid var(--v-secondary-base) !important;
                          "
                        >
                          {{ `${$t("poll.lblSection")} ${index + 1}` }}
                        </a-chip>
                      </span>
                    </v-col>
                    <v-col cols="10" class="ma-auto pl-3">
                      <v-tooltip bottom :disabled="!isEllipsis(section.title)">
                        <template v-slot:activator="{ on, attrs }">
                        <div 
                        v-bind="attrs"
                        v-on="on"
                        >
                          <span v-if="open" key="0">
                            {{ section.title !== "" ? ellipsis(section.title) : "" }}
                          </span>
                          <span v-else key="1">
                            {{ ellipsis(section.title) }}
                          </span>
                        </div>
                        </template>
                        <span>{{section.title !== '' ? section.title : ''}}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:actions>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" class="white--text">
                        <v-icon class="white--text" v-if="PanelSeq == index"
                          >mdi-menu-up
                        </v-icon>
                        <v-icon class="white--text" v-else
                          >mdi-menu-down
                        </v-icon>
                      </v-btn>
                    </template>
                    <span v-if="PanelSeq == index">{{
                      $t("lblCollapse")
                    }}</span>
                    <span v-else>{{ $t("lblExpand") }}</span>
                  </v-tooltip>
                  <section-delete-menu
                    :section="section"
                    v-if="!isSectionDeleted(section)"
                    @sectionDelete="onSectionDelete"
                  ></section-delete-menu>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" class="pa-2">
                    <survey-section v-model="sections[index]"></survey-section>
                    <questions-panel
                      v-model="questionsList"
                      :panel.sync="questionPanel"
                      :id="section.sectionId"
                      max-width="100%"
                    />
                    <add-question-card
                      @addQuestions="addQuestions(section.sectionId)"
                      :sectionId="section.sectionId"
                      :placedInSection="true"
                      max-width="100%"
                      v-if="surveyeButtonDisable && !isSurveyExpired"
                    ></add-question-card>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </a-expansion-panel>
          </draggable>
        </v-expansion-panels>
      </v-card-text>
    </v-card>
    <confirm-dialog ref="confDelete" />
  </div>
</template>

<script>
import QuestionsPanel from "./QuestionsPanel.vue";
import typeComponents from "../poll/components/index";
import SurveySection from "./components/SurveySection.vue";
import AddQuestionCard from "./AddQuestionCard.vue";
import SectionDeleteMenu from "./SectionDeleteMenu.vue";
import draggable from "vuedraggable";
import ConfirmDialog from "../ConfirmDialog.vue";
import { mapMutations, mapState, mapGetters } from "vuex";

export default {
  components: {
    QuestionsPanel,
    SurveySection,
    AddQuestionCard,
    SectionDeleteMenu,
    draggable,
    ConfirmDialog,
  },
  name: "SectionPanel",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    panel: Number,
    surveyeButtonDisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      questionPanelIndex: 0,
      stringLength: 180
    };
  },
  mounted() {
    this.emitInterface();
  },
  computed: {
    ...mapState({
      surveyResponseResult: (state) => state.poll.surveyResponseResult,
    }),
    ...mapGetters({
      isSurveyExpired: "poll/isSurveyExpired",
    }),
    surveyDetails: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || {});
      },
    },
    questionsList() {
      return this.surveyDetails.questions;
    },
    sections: {
      get() {
        return this.surveyDetails.sections;
      },
      set(value) {
        this.surveyDetails.sections = value;
      },
    },
    PanelSeq: {
      get() {
        return this.panel;
      },
      set(value) {
        this.$emit("update:panel", value);
      },
    },

    questionPanel: {
      get() {
        return this.questionsList.length > 0
          ? this.questionsList.length - 1
          : 0;
      },
      set(val) {
        this.questionPanelIndex = val;
      },
    },
  },
  methods: {
    ...mapMutations({
      deleteJustSection: "poll/DELETE_JUST_SECTION",
    }),
    emitInterface() {
      this.$emit("interface", {
        openSection: (seq) => this.openSection(seq),
      });
    },
    openSection,
    loadTypeComponent,
    addQuestions,
    onSectionDelete,
    isSectionDeleted,
    ellipsis,
    isEllipsis
  },
};
function ellipsis(string) {
  return  this.isEllipsis(string) ? string.substring(0, this.stringLength) + "..." : string;
}

function isEllipsis(string) {
  return  String(string).length > this.stringLength;
}

function isSectionDeleted(section) {
  let isResponseExist = false;
  const questionsData = this.questionsList.filter(
    (q) => q.sectionId === section.sectionId
  );
  if(this.surveyResponseResult && this.surveyResponseResult.length > 0){
    for (let index = 0; index < questionsData.length; index++) {
      const element = questionsData[index];
      const result = this.surveyResponseResult.some((s) =>
        s.questionAnswers.some((a) => a.questionId === element.id)
      );
      if (result) {
        isResponseExist = result;
        break;
      }
    }
  }
  return isResponseExist;
}

function openSection(seq) {
  this.PanelSeq = Number(seq);
}

async function onSectionDelete(section) {
  if (this.sections.length > 1) {
    const index = this.sections.findIndex(
      (value) => value.sectionId === section.sectionId
    );
    const label =
      this.sections.length === index + 1
        ? this.$t("Previous")
        : this.$t("Next");
    if (
      await this.$refs.confDelete.open(
        this.$t("agenda.hDeleteMessage"),
        this.$t("poll.lblSectionDeleteMessage", {
          position: label.toLowerCase(),
        })
      )
    ) {
      this.deleteJustSection(section.sectionId);
    }
  } else {
    this.deleteJustSection(section.sectionId);
  }
}

function addQuestions(id) {
  this.$root.$emit("add-question-type", id);
}

function loadTypeComponent(type) {
  return typeComponents[type] || null;
}
</script>

<style scoped>
.questions-drag-icon {
  color: rgba(white, 0.35);
  cursor: move;
  margin-right: 0.8rem;
}
</style>